import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Stable per-browser id so we can group a visitor's looks across pages/sessions.
function getVisitorId() {
  try {
    let id = localStorage.getItem("tacc_vid");
    if (!id) {
      id = "v_" + (crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem("tacc_vid", id);
    }
    return id;
  } catch {
    return "v_anon";
  }
}

// Log a "look" at a product/service. kind: "page" | "module" | "book".
const _recent = new Map();
export function trackInterest(kind, id, label = "") {
  try {
    const key = `${kind}:${id}`;
    const now = Date.now();
    // Collapse StrictMode double-effects / rapid re-mounts; a genuine revisit later still counts.
    if (_recent.get(key) && now - _recent.get(key) < 3000) return;
    _recent.set(key, now);
    axios.post(`${API}/analytics/interest`, {
      visitor_id: getVisitorId(),
      kind,
      id: String(id),
      label: label || "",
      path: typeof window !== "undefined" ? window.location.pathname : "",
    }).catch(() => {});
  } catch { /* never break the page for analytics */ }
}

// Convenience: fire a page-view "look" once on mount.
export function useTrackView(id, label = "") {
  useEffect(() => {
    trackInterest("page", id, label);
  }, [id, label]);
}
